import addOnsActive from "../../assets/icons/menu_icon/add-ons-active.svg";
import addOnsIcon from "../../assets/icons/menu_icon/add-ons-icon.svg";
import settingActive from "../../assets/icons/menu_icon/settings-dark.svg";
import setting from "../../assets/icons/menu_icon/settings-light.svg";
import carIconActive from "../../assets/icons/menu_icon/car-icon-active.svg";
import carIcon from "../../assets/icons/menu_icon/car-icon.svg";
import customerIconActive from "../../assets/icons/menu_icon/customer-icon-active.svg";
import customerIcon from "../../assets/icons/menu_icon/customer-icon.svg";
import dashboardIconActive from "../../assets/icons/menu_icon/dashboard-icon-active.svg";
import dashboardIcon from "../../assets/icons/menu_icon/dashboard-icon.svg";
import reservationIconActive from "../../assets/icons/menu_icon/res-icon-acitve.svg";
import reservationIcon from "../../assets/icons/menu_icon/res-icon.svg";
import shareGrowIcon from "../../assets/icons/menu_icon/share-grow-icon-active.svg";
import shareGrowIconActive from "../../assets/icons/menu_icon/share-grow-icon.svg";
import insuranceIconActive from "../../assets/icons/menu_icon/insurance-icon-active.png";
import FEATURE_FLAGS from "../../config/featureFlags";
import insuranceIcon from "../../assets/icons/menu_icon/insurance-icon.png";
import buyInsuranceIconActive from "../../assets/icons/menu_icon/buy-insurance-icon-active.svg";
import buyInsuranceIcon from "../../assets/icons/menu_icon/buy-insurance-icon.svg";
import tollIconActive from "../../assets/icons/menu_icon/toll-icon-active.svg";
import tollIcon from "../../assets/icons/menu_icon/toll-icon.svg";

const getSidebarMenuItems = (t) => {
    const menuItems = [
        {
            to: "/",
            text: t("dashboard"),
            icon: dashboardIcon,
            activeIcon: dashboardIconActive,
            tourId: "sidebar-dashboard",
        },
        {
            to: "/reservations",
            text: t("reservations"),
            icon: reservationIcon,
            activeIcon: reservationIconActive,
            tourId: "sidebar-reservations",
        },
        {
            to: "/share-grow",
            text: t("shareGrow"),
            icon: shareGrowIcon,
            activeIcon: shareGrowIconActive,
            tourId: "sidebar-share-grow",
        },
        {
            to: "/customers",
            text: t("customers"),
            icon: customerIcon,
            activeIcon: customerIconActive,
            tourId: "sidebar-customers",
        },
        {
            to: "/cars",
            text: t("cars"),
            icon: carIcon,
            activeIcon: carIconActive,
            tourId: "sidebar-cars",
        },
        {
            to: "/tolls",
            text: t("tolls"),
            icon: tollIcon,
            activeIcon: tollIconActive,
        },
        {
            to: "/insurance",
            text: t("insurance"),
            icon: insuranceIcon,
            activeIcon: insuranceIconActive,
            tourId: "sidebar-insurance",
        },
        {
            to: "/sell-insurance",
            text: t("buyInsurance"),
            icon: buyInsuranceIcon,
            activeIcon: buyInsuranceIconActive,
            tourId: "sidebar-buy-insurance",
        },
        {
            to: "/settings",
            text: t("settings"),
            icon: setting,
            activeIcon: settingActive,
            tourId: "sidebar-settings",
        },
    ];

    if (FEATURE_FLAGS.addons) {
        menuItems.push({
            to: "/add-ons",
            text: t("addOns"),
            icon: addOnsIcon,
            activeIcon: addOnsActive,
        });
    }

    return menuItems;
};

export default getSidebarMenuItems;
